// Donne a GlitchTip l'identite minimale de la session : sId du membre et du workspace, jamais
// l'e-mail. Monte a la racine du routeur seulement quand la remontee est demarree. Le contexte
// d'auth est celui que WorkspacePage charge deja (meme cle SWR : aucune requete en plus) ; hors
// d'un workspace, rien n'est demande.
import { useAuthContext } from "@dust-tt/front/lib/swr/workspaces";
import { identifierPourSentry } from "@spa/lib/erreurs_sentry";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function IdentiteSentry() {
  const { pathname } = useLocation();
  const workspace = pathname.match(/^\/w\/([^/]+)/)?.[1] ?? null;
  const { authContext } = useAuthContext({
    workspaceId: workspace ?? "",
    disabled: !workspace,
  });
  const utilisateur = authContext?.user?.sId ?? null;

  useEffect(() => {
    identifierPourSentry({ utilisateur, workspace });
  }, [utilisateur, workspace]);

  return null;
}
